import i18n from '@/utils/i18n';
import React, { useMemo } from 'react';
import { createStyles } from '@/contexts/theme-context';
import { getContentSegments, useInboundMessageStyles } from './utils';
import { OrderMetadata } from './types';
import { Text } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  onSelect?: (matchTerm: string) => void;
  order: OrderMetadata;
  selectedInputUUID?: string;
  showTranslation?: boolean;
}

export const OriginalInboundText: React.FC<Props> = ({
  order,
  onSelect,
  selectedInputUUID,
  showTranslation,
}) => {
  const [styles] = useStyles();
  const [inboundMessageStyles] = useInboundMessageStyles();

  const content = useMemo<React.ReactNode[]>(() => {
    const segments = getContentSegments(
      order,
      showTranslation ? i18n.locale : undefined,
    );

    return segments.map((segment, index) => {
      if (segment.type === 'match') {
        return (
          <Text
            key={`${order.smartOrderUUID}-${index}`}
            onPress={
              onSelect && segment.searchInputUUID
                ? () => onSelect(segment.searchInputUUID!)
                : undefined
            }
            style={[
              inboundMessageStyles.textHighlighted,
              selectedInputUUID === segment.searchInputUUID
                ? inboundMessageStyles.textSelected
                : null,
            ]}
          >
            {segment.text}
          </Text>
        );
      }

      return (
        <Text key={`${order.smartOrderUUID}-${index}`} style={styles.textColor}>
          {segment.text}
        </Text>
      );
    });
  }, [
    order,
    onSelect,
    inboundMessageStyles,
    selectedInputUUID,
    showTranslation,
    styles,
  ]);

  return (
    <Text
      style={[
        TYPOGRAPHY.description,
        inboundMessageStyles.text,
        styles.textContent,
        styles.textColor,
      ]}
    >
      {content}
    </Text>
  );
};

const useStyles = createStyles((theme) => ({
  textColor: {
    color: theme.sk.color.text.primary,
  },
  textContent: {
    lineHeight: 24,
  },
}));
